import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-loading-spinner",
  templateUrl: "./loading-spinner.component.html",
  styleUrls: ["./loading-spinner.component.css"],
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() message: string;
  @Input() showProgress: boolean = false;
  @Input() progress: number = 0;
  @Input() type: 'default' | 'download' | 'upload' | 'process' = 'default';

  constructor() {}

  ngOnInit(): void {}

  getIcon(): string {
    switch (this.type) {
      case 'download':
        return 'fa-download';
      case 'upload':
        return 'fa-upload';
      case 'process':
        return 'fa-cogs';
      default:
        return 'fa-spinner';
    }
  }
}
